import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: #b10000;
      font-size: 1.3rem;
      margin: 0;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;
    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  margin-top: 1rem;

  h2 {
    margin-right: 0.5rem;
  }

  div {
    margin: 0.1rem 0;
  }

  .contentFlex {
    display: flex;
    align-items: center;

    p {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 22px;
      font-weight: 700;
      font-family: 'Futura PT';
    }

    margin-bottom: 1rem;
  }

  .contentSolicitationOpened {
    margin-top: 0.5rem;
    height: 7.5rem;
    position: relative;
    overflow-x: scroll;
  }

  .confirmationText {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 300;
  }

  .contentSolicitations {
    margin-top: 1rem;

    .info {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 14px;
      font-weight: 700;
      font-family: 'Futura PT';
    }
  }

  .buttonModal {
    display: flex;
    justify-content: space-around;
    margin: 2rem 1rem 0 0;
  }

  @media (max-width: 450px) {
    .buttonModal {
      margin: 2rem 0 0 0;
    }
  }
`;
